import styled from 'styled-components'
import { GREEN, GREY_MEDIUM, WHITE } from '../../utils/colors'

export const Container = styled.div`
  min-height: 60px;
  .select_input {
    min-height: 60px;

    [class*='-MenuList'] {
      padding: 0px;
    }

    [id*='-input'] {
      margin-left: 12px;
    }

    [class*='-option'] {
      color: ${GREY_MEDIUM};
      font-size: 18px;
      line-height: 24px;

      &:hover {
        background: ${GREEN};
        color: ${WHITE};
      }
    }

    [class*='-menu'] {
      background: ${WHITE};
      border: 1px solid #E7E7E7;
      border-radius: 4px;
    }

    [class*='-ValueContainer'] {
      padding-left: 20px;
      margin-bottom: -12px;
      color: ${GREEN};
      font-size: 18px;
      line-height: 24px;
      outline: none;
      background: transparent;
      font-family: 'Segoe UI', sans-serif;
    }

    [class*='-singleValue'] {
      color: ${GREEN};
      left: 19px;
      font-size: 18px;
      margin-top: 5px;
    }

    [class*='-indicatorSeparator'] {
      opacity: 0;
    }

    [class*='-indicatorContainer'] {
      svg {
        fill: ${GREEN};
      }
    }

    [class*='-control'] {
      min-height: 60px;
      border: none !important;
      box-shadow: none !important;
    }
  }
`
